import client from 'api/client'

export const transcribe = ({url, uid, locale, languageCode, oid: orgId, name, beta, isPrecision, dictionary}) =>
  client().post(`/pipeline/user/${uid}/collections/`, {url, locale, orgId, languageCode, beta, name, isPrecision, dictionary})

export const check = ({url}) => client().post('/pipeline/check', {url})
